import React from "react";
import Button from "react-bootstrap/Button";
import {AiOutlineGithub, AiOutlineRight} from "react-icons/ai";
import { Row, Col} from "react-bootstrap";
import { projects } from "../Models";

function ProjectCards() {
  return (


    <div class="card">
        {projects.map((project) => (
            <div>
            <div class="card-header" style={{textAlign:"left"}}><h3>{project.title}</h3></div>
            <Row>
            <Col md={7} className="project-card" style={{textAlign:"left"}}>

            <div class="d-flex justify-content-start">
  {project.stack.map(film => (
        <div class="p-2" style={{backgroundColor:"rgb(245,245,245)", fontWeight: "bold"}}>{film}</div>

    ))}

  </div>

            
            <p>{project.description}</p>
            <Button variant="primary" href={project.livePreview} style={{marginRight:"20px"}} target="_blank" rel="noreferrer">
           <AiOutlineRight />
        </Button>
        <Button variant="primary" href={project.sourceCode} target="_blank" rel="noreferrer">
           <AiOutlineGithub/>
        </Button>
          </Col>
          <Col md={4} className="project-card">
                <a href={project.link} target="_blank" rel="noreferrer">
              <img src={project.image} alt={project.name} className="project_card_img" />
              </a>
          </Col>
          </Row>
          </div>
          ))}

       </div>
);
}
export default ProjectCards;
